import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getLookupsOATypes = async () => {
	const { data } = await axios.get(`${API}/maintainers/order-application/type-oa/lookups`);
	return data;
};

export const getOATypes = async (filters) => {
	const { data } = await axios.get(`${API}/maintainers/order-application/type-oa/list`, { params: filters });
	return data;
};

export const getOAType = async (filters, element_id) => {
	const { data } = await axios.get(`${API}/maintainers/order-application/type-oa/detail`, { params: { ...filters, element_id } });
	return data;
};

export const saveOAType = async (params) => {
	const { data } = await axios.post(`${API}/maintainers/order-application/type-oa`, params);
	return data;
};

export const deleteOAType = async (params) => {
	const { data } = await axios.post(`${API}/maintainers/order-application/type-oa/delete`, params);
	return data;
};
